import React, {Component, PropTypes} from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import {bindActionCreators} from 'redux';
import {autobind} from 'core-decorators';
import {connect} from 'store';
import {isMobile} from 'utils';
import * as uiActions from 'store/ui/actions';
import * as searchActions from 'store/search/actions';
import {getHeatmapBlocks} from 'store/element-list/selectors';
import Block from './block';

export class Heatmap extends Component {
    static propTypes = {
        blocks: ImmutablePropTypes.list.isRequired,
        duration: PropTypes.number.isRequired,
        currentTimeNormalized: PropTypes.number.isRequired,
        tooltipIndex: PropTypes.number.isRequired,
        tooltipExpandedIndex: PropTypes.number.isRequired,
        tooltipAnimation: PropTypes.bool.isRequired,
        tooltipOpenDown: PropTypes.bool.isRequired,
        rootWidth: PropTypes.number.isRequired,
        showTooltip: PropTypes.func.isRequired,
        hideTooltip: PropTypes.func.isRequired,
        expandTooltip: PropTypes.func.isRequired,
        seekToHeatmapBlock: PropTypes.func.isRequired,
        searchEntityGroup: PropTypes.func.isRequired,
    };

    shouldComponentUpdate(nextProps) {
        return nextProps.blocks !== this.props.blocks
            || nextProps.duration !== this.props.duration
            || nextProps.currentTimeNormalized !== this.props.currentTimeNormalized
            || nextProps.tooltipIndex !== this.props.tooltipIndex
            || nextProps.tooltipExpandedIndex !== this.props.tooltipExpandedIndex
            || nextProps.tooltipAnimation !== this.props.tooltipAnimation
            || nextProps.tooltipOpenDown !== this.props.tooltipOpenDown
            || nextProps.rootWidth !== this.props.rootWidth;
    }

    getTooltipDelay() {
        return isMobile() ? 0 : 250;
    }

    @autobind
    showTooltip(block) {
        clearTimeout(this.tooltipTimeoutId);
        const callback = () => this.props.showTooltip(block);
        if (this.props.tooltipIndex !== -1) callback();
        else this.tooltipTimeoutId = setTimeout(callback, this.getTooltipDelay());
    }

    @autobind
    hideTooltip(block) {
        clearTimeout(this.tooltipTimeoutId);
        if (this.props.tooltipIndex !== -1) {
            const callback = () => this.props.hideTooltip(block);
            this.tooltipTimeoutId = setTimeout(callback, this.getTooltipDelay());
        }
    }

    render() {
        const {blocks, currentTimeNormalized, rootWidth, tooltipAnimation, tooltipOpenDown} = this.props;
        const {tooltipIndex, tooltipExpandedIndex} = this.props;
        const playheadPosition = {transform: `translateX(${Math.round(currentTimeNormalized * rootWidth)}px)`};

        if (blocks.size === 0) return null;

        return (
            <div className='cielo24-vwrap-heatmap'>
                <div className='cielo24-vwrap-blocks'>
                    {blocks.map(block => (
                        <Block
                            key={block.get('index')}
                            block={block}
                            tooltipVisible={block.get('index') === tooltipIndex}
                            tooltipExpanded={block.get('index') === tooltipExpandedIndex}
                            tooltipAnimation={tooltipAnimation}
                            tooltipOpenDown={tooltipOpenDown}
                            rootWidth={rootWidth}
                            showTooltip={this.showTooltip}
                            hideTooltip={this.hideTooltip}
                            expandTooltip={this.props.expandTooltip}
                            onClick={this.props.seekToHeatmapBlock}
                            onEntityClick={this.props.searchEntityGroup}
                        />
                    ))}
                </div>
                <div className='cielo24-vwrap-playhead' style={playheadPosition} />
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    blocks: getHeatmapBlocks(state),
    duration: state.video.get('duration'),
    currentTimeNormalized: state.video.get('currentTimeNormalized'),
    tooltipIndex: state.ui.get('heatmapTooltipIndex'),
    tooltipExpandedIndex: state.ui.get('heatmapTooltipExpandedIndex'),
    tooltipAnimation: state.ui.get('heatmapTooltipAnimation'),
    tooltipOpenDown: Boolean(state.config.get('domContainer')),
    rootWidth: state.ui.get('width'),
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    showTooltip: uiActions.showHeatmapTooltip,
    hideTooltip: uiActions.hideHeatmapTooltip,
    expandTooltip: uiActions.expandHeatmapTooltip,
    seekToHeatmapBlock: uiActions.seekToHeatmapBlock,
    searchEntityGroup: searchActions.searchEntityGroupFromHeatmap,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Heatmap);



// WEBPACK FOOTER //
// ./scripts/components/heatmap/heatmap.js